import {ChangeDetectionStrategy, Component, OnChanges, ViewChild} from '@angular/core';
import {
    AnalyticsChartWidgetComponent,
    ChartWidgetSeriesStrict,
} from 'app/features/analytics/shared/components/analytics-chart-widget/analytics-chart-widget.component';
import {HighChartComponent} from 'app/features/analytics/shared/components/high-chart/high-chart.component';
import {MonetizationTooltipStateService} from 'app/features/analytics/features/monetization/service/monetization-tooltip-state.service';
import {StatsService} from 'app/features/analytics/service/stats.service';
import {DimensionsAndMeasuresService} from 'app/features/analytics/service/dimensions-and-measures.service';
import {SingleMeasureChartDateMapperService} from 'app/features/analytics/features/business-overview/services/single-measure-chart-date-mapper.service';
import {I18nextFormattersService} from 'app/core/services/i18next-formatters.service';
import {ThemeCustomizationService} from 'app/core/services/theme-customization.service';
import {measureColumnKey} from 'app/features/analytics/shared/components/analytics-table/analytics-table.helpers';

@Component({
    selector: 'analytics-chart-widget-stateful',
    templateUrl: './analytics-chart-widget-stateful.component.html',
    styleUrls: ['../analytics-chart-widget/analytics-chart-widget.component.scss', './analytics-chart-widget-stateful.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnalyticsChartWidgetStatefulComponent extends AnalyticsChartWidgetComponent implements OnChanges {
    @ViewChild(HighChartComponent, {static: true}) chartContainer: HighChartComponent;

    get isMultiTooltip() {
        return this.multipleTooltip === undefined ? this.tooltipService.multipleTooltip : this.multipleTooltip;
    }

    constructor(
        protected statsService: StatsService,
        protected dms: DimensionsAndMeasuresService,
        protected cdm: SingleMeasureChartDateMapperService,
        protected formats: I18nextFormattersService,
        protected themeSettings: ThemeCustomizationService,
        public tooltipService: MonetizationTooltipStateService
    ) {
        super(statsService, dms, cdm, formats, themeSettings);
    }

    ngOnChanges() {
        super.ngOnChanges();
    }

    protected buildSeries(data, filters, m: ChartWidgetSeriesStrict, totalSeries: any, categories?: string[]) {
        return this.cdm.buildSeries(
            data,
            filters,
            m.metric,
            {
                type: m.type === 'line' ? 'line' : 'column',
                yAxis: this.getMetricAxis(m.metric),
                name: m.metric.label,
                enabled: true,
                color: m.axisColor,
                totalSeries,
                tooltip: {
                    pointFormatter: this.formats.pointFormatter(this.formats.getMeasureFormatter(m.metric.id), m.type !== 'line'),
                    valueFormatter: this.formats.getMeasureFormatter(m.metric.id),
                },
                id: measureColumnKey(m.metric),
            },
            {sorted: true, categories, datesOnAxis: Boolean(this.dateGranularity)}
        );
    }

    toggleSeriesVisibility(show: boolean) {
        return this.chartContainer.toggleSeriesVisibility(show);
    }

    toggleAppearanceTooltip() {
        this.tooltipService.toggleAppearanceTooltip();
    }
}
